import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PopupDriverScheduleComponent } from './popup-driver-schedule.component';

const routes: Routes = [{  path: 'i-driverschedule/:id',
component: PopupDriverScheduleComponent,
data: {
    title: 'Auto routing'
  }
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class PopupDriverScheduleRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/popup-driver-schedule/popup-driver-schedule-routing.module.ts